import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BasePipe } from 'app/generated/generated-common';
import { of } from 'rxjs';
export enum ContentBodyFormat {
	None = 0,
	Text = 1,
	Html = 2,
	Json = 3,
	Blocks = 4,
}

@Pipe({
name: 'contentBodyFormat'
})
export class ContentBodyFormatPipe extends BasePipe<ContentBodyFormat> implements PipeTransform {
	static prefix = 'Backend.Content.Api.ContentBodyFormat.';
	static keys = [
		ContentBodyFormat.None,
		ContentBodyFormat.Text,
		ContentBodyFormat.Html,
		ContentBodyFormat.Json,
		ContentBodyFormat.Blocks];
	constructor(
		protected translateService: TranslateService
	) {
		super(translateService);
	}
	toString(value: ContentBodyFormat): string {
		if (value == null) {
			return null;
		}
		switch (value) {
			case ContentBodyFormat.None: return 'None';
			case ContentBodyFormat.Text: return 'Text';
			case ContentBodyFormat.Html: return 'Html';
			case ContentBodyFormat.Json: return 'Json';
			case ContentBodyFormat.Blocks: return 'Blocks';
			default: return null;
		}
	}
	transform(value: ContentBodyFormat, suffix: string, interpolateParams?: Object) {
		const str = this.toString(value);
		if (str) {
			return this.translateOne(ContentBodyFormatPipe.prefix + str, suffix, interpolateParams);
		}
		return of(null);
	}
}


@NgModule({
	imports: [
		CommonModule,
		TranslateModule
	],
	declarations: [
		ContentBodyFormatPipe
	],
	exports: [
		ContentBodyFormatPipe
	],
	providers: [
		ContentBodyFormatPipe
	]
})
export class ContentBodyFormatModule { }
